/* eslint-disable no-shadow */

// initial state
import { APIPOST } from '@/utils/apiHelper';

const state = {
  calcDataId: null,
  partnerName: '',
  // partnerType = PARTNER | CUSTOMER
  partnerType: 'CUSTOMER',
  // campaignName: null | 'A52S',
  campaignName: null,
};

// getters
const getters = {
  getPartnerName(state) {
    return state.partnerName;
  },
  getPartnerType(state) {
    return state.partnerType;
  },
  getCampaignName(state) {
    return state.campaignName;
  },
};

// actions
const actions = {
  async calculateDataId(context, request) {
    const formData = new FormData();
    const temp = request;
    const requestJSON = JSON.stringify(temp);
    formData.append('data', requestJSON);
    const response = await APIPOST('store-management/calc-data/hu', formData);
    if (response.status === 201) {
      context.commit('setCalcDataId', response.data.calcDataId);
    }
    return response;
  },
  async sendCustomerData(context, credentials) {
    const formData = new FormData();
    const temp = credentials.customer;
    const requestJSON = JSON.stringify(temp);
    formData.append('data', requestJSON);
    formData.append('invoice', credentials.invoice);
    formData.append('pre_order', credentials.preOrderDoc);
    const response = await APIPOST('store-management/customer-data/hu', formData);
    return response;
  },
  async sendAdditionalCustomerData(context, request) {
    const formData = new FormData();
    const temp = request;
    const requestJSON = JSON.stringify(temp);
    formData.append('data', requestJSON);
    const response = await APIPOST('store-management/customer-additional-data/hu', formData);
    return response.status;
  },
};

// mutations
const mutations = {
  setCalcDataId(state, payload) {
    state.calcDataId = payload;
  },
  setPartnerName(state, payload) {
    state.partnerName = payload;
  },
  setPartnerType(state, payload) {
    state.partnerType = payload;
  },
  setCampaignName(state, payload) {
    state.campaignName = payload;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
